var _excluded = ["className", "active", "disabled", "danger", "help", "onClick"],
    _excluded2 = ["copyable", "copyValue", "ellipsis", "tooltip", "danger", "disabled", "active", "children", "title", "value", "ellipsisClassName", "copyClassName", "tooltipClassName", "className", "placement"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useCallback, useState } from 'react';
import classNames from 'classnames';
import { noop } from 'lodash';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { IconCopy, IconSuccessSolid, IconQuestionMark } from '@baidu/lsqm-icon';
import { Tooltip } from '@osui/ui';
import Ellipsis from '@baidu/icloud-ui-ellipsis';
import './index.less';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var CopyData = function CopyData(_ref) {
  var value = _ref.value,
      className = _ref.className;

  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      canCopy = _useState2[0],
      setCancopy = _useState2[1];

  var onCopy = useCallback(function () {
    setCancopy(false);
    setTimeout(function () {
      setCancopy(true);
    }, 2000);
  }, []);

  if (value) {
    return canCopy ? /*#__PURE__*/_jsx(CopyToClipboard, {
      text: value,
      onCopy: onCopy,
      children: /*#__PURE__*/_jsx("span", {
        className: classNames('icloud-ui-text-copy', className),
        children: /*#__PURE__*/_jsx(IconCopy, {})
      })
    }) : /*#__PURE__*/_jsx("span", {
      className: "icloud-ui-text-copy-success",
      children: /*#__PURE__*/_jsx(IconSuccessSolid, {})
    });
  }

  return null;
};

var TextSpan = function TextSpan(_ref2) {
  var className = _ref2.className,
      active = _ref2.active,
      disabled = _ref2.disabled,
      danger = _ref2.danger,
      help = _ref2.help,
      onClick = _ref2.onClick,
      restProps = _objectWithoutProperties(_ref2, _excluded);

  var element = /*#__PURE__*/_jsx("span", _objectSpread(_objectSpread({
    className: classNames('icloud-ui-text-span', {
      'icloud-ui-text-span-active': active && !disabled,
      'icloud-ui-text-span-disabled': disabled,
      'icloud-ui-text-span-error': danger
    }, className)
  }, restProps), {}, {
    onClick: disabled ? noop : onClick
  }));

  if (help) {
    return /*#__PURE__*/_jsxs("div", {
      style: {
        display: 'flex',
        alignItems: 'center'
      },
      children: [element, /*#__PURE__*/_jsx(Tooltip, {
        title: help,
        children: /*#__PURE__*/_jsx(IconQuestionMark, {
          className: "icloud-ui-text-span-help-icon"
        })
      })]
    });
  }

  return element;
};

var Text = function Text(_ref3) {
  var copyable = _ref3.copyable,
      copyValue = _ref3.copyValue,
      ellipsis = _ref3.ellipsis,
      tooltip = _ref3.tooltip,
      danger = _ref3.danger,
      disabled = _ref3.disabled,
      active = _ref3.active,
      children = _ref3.children,
      title = _ref3.title,
      value = _ref3.value,
      ellipsisClassName = _ref3.ellipsisClassName,
      copyClassName = _ref3.copyClassName,
      tooltipClassName = _ref3.tooltipClassName,
      className = _ref3.className,
      placement = _ref3.placement,
      restProps = _objectWithoutProperties(_ref3, _excluded2);

  var valueIn = children !== null && children !== void 0 ? children : value;
  var copyValueIn = copyValue || valueIn;

  if (['undefined', 'null', ''].includes(String(valueIn))) {
    return /*#__PURE__*/_jsx(TextSpan, {
      disabled: true,
      children: "-"
    });
  }

  var element = /*#__PURE__*/_jsx(TextSpan, _objectSpread(_objectSpread({
    disabled: disabled,
    active: active,
    danger: danger,
    className: className
  }, restProps), {}, {
    children: valueIn
  }));

  var withElipsis = ellipsis ? /*#__PURE__*/_jsx(Ellipsis, {
    className: ellipsisClassName,
    children: element
  }) : element;
  var withCopyable = copyable ? /*#__PURE__*/_jsxs("div", {
    className: classNames(ellipsis ? 'icloud-ui-text-ellipsis' : 'icloud-ui-text-ellipsis-copy'),
    children: [withElipsis, /*#__PURE__*/_jsx(CopyData, {
      value: String(copyValueIn),
      className: copyClassName
    })]
  }) : withElipsis;
  return tooltip ? /*#__PURE__*/_jsx(Tooltip, {
    title: title || valueIn,
    className: tooltipClassName,
    placement: placement,
    children: withCopyable
  }) : withCopyable;
};

export default Text;
//# sourceMappingURL=es/index.js.map